interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="w-full py-16 flex flex-col items-center justify-center text-center rounded-lg border border-dashed border-background-300 bg-background-100">
      <span className="w-16 h-16 rounded-full bg-background-200 text-foreground-400 flex items-center justify-center mb-4">
        <i className="ri-movie-2-line text-3xl" />
      </span>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-md px-4">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}